// LoginPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  Button,
  IconButton,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import logo from "./Outils/Images/Agapes_Logo.png";
import { setToken } from "./Outils/auth";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { API_URI } from "./Outils/Api/FetchData";
import { colors } from "./Outils/Colors";

export default function LoginPage({ setUserRole }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
  setErrorMsg("");

  if (!username || !password) {
    setErrorMsg("Veuillez remplir tous les champs.");
    return;
  }

  try {
    const response = await fetch(`${API_URI}user/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: username, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Problème de connexion");
    }

    if (data.token && data.role) {
      setToken(data.token);
      localStorage.setItem("role", JSON.stringify(data.role));
      localStorage.setItem("zone", JSON.stringify(data.zone));
      localStorage.setItem("mp", JSON.stringify(data.mp));

      if (data.site && data.role === "Gouvernante") {
        localStorage.setItem("site", JSON.stringify(data.site));
      }

      setUserRole(data.role);
      navigate("/home");
      window.location.reload();
    } else {
      setErrorMsg("Réponse inattendue du serveur.");
    }
  } catch (err) {
    console.error("Login error:", err);
    setErrorMsg(err.message || "Impossible de joindre le serveur.");
  }
};
  const toggleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <Box
      sx={{
        minHeight: "96vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(90deg, ${colors.primary} 40%, ${colors.secondary} 80%)`,
        p: 2,
      }}
    >
      <Card
        elevation={8}
        sx={{
          maxWidth: 450,
          width: "100%",
          borderRadius: 3,
          backdropFilter: "blur(10px)",
          bgcolor: colors.primary,
        }}
      >
        <CardContent sx={{ textAlign: "center", py: 2 }}>
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              width: 220, // largeur souhaitée
              height: 130,
              mx: "auto",
              mb: 2,
              borderRadius: 2, // optionnel (pour des coins très légèrement arrondis, sinon mets 0)
              objectFit: "contain", // ou "cover" selon le rendu voulu
              display: "block",
            }}
          />

          <Box component="form" noValidate sx={{ mt: 2 }}>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{
                mb: 2,
                "& .MuiInputBase-input": {
                  color: "#fff",
                },
                "& .MuiInputLabel-root": {
                  color: "#fff",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#fff",
                },
                "& .MuiInputAdornment-root": {
                  color: "#fff",
                },
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#fff",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Mot de passe"
              variant="outlined"
              fullWidth
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                mb: 1,
                "& .MuiInputBase-input": {
                  color: "#fff",
                },
                "& .MuiInputLabel-root": {
                  color: "#fff",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#fff",
                },
                "& .MuiInputAdornment-root": {
                  color: "#fff",
                },
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#fff",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon color="action" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={toggleShowPassword}
                      edge="end"
                      aria-label={
                        showPassword
                          ? "Cacher le mot de passe"
                          : "Afficher le mot de passe"
                      }
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {errorMsg && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {errorMsg}
              </Typography>
            )}

            <Button
              variant="contained"
              fullWidth
              onClick={handleLogin}
              sx={{
                mt: 3,
                py: 1.5,
                bgcolor: colors.secondary,
                fontWeight: 600,
                transition: "background-color 200ms ease",
                "&:hover": { bgcolor: colors.muted },
              }}
            >
              Se connecter
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
